<template>
  <b-jumbotron>
    <b-container>
      <b-row>
        <b-col>
          <h1>{{ title }}</h1>
          <h5>{{ subtitle }}</h5>
        </b-col>
        <b-col class="text-right">
          <slot />
        </b-col>
      </b-row>
    </b-container>
  </b-jumbotron>
</template>

<script>
export default {
  name: 'AppHeader',

  props: {
    title: {
      type: String,
      default: '',
    },

    subtitle: {
      type: String,
      default: '',
    },
  },
};
</script>
